<h4>{{ engagement.name }} Permissions</h4>
<div style="margin-top:20px;"></div>

<!--list of assigned permisisons -->
@for (permission of engagement.permissions; track permission) {
    <div>
        <!-- select list of permissions for screen type -->
        @if (userHasInstanceRight(permission)) {
            <select class="form-select form-select-sm" style="width: 100px; display: inline-block;"
                    [(ngModel)]="permission.instanceRightID"
                    (change)="rightSelected(permission)"
            >
                @for (permission of availablePermissionRights(permission.screenTypeID); track permission) {
                    <option [ngValue]="permission.instanceRightID">
                        {{ permission.rights }}
                    </option>
                }
            </select>
        }
        <!-- label if right is assigned but user does not have it-->
        @if (!userHasInstanceRight(permission)) {
            <span style="width: 100px; display: inline-block;"
                  class="application-permission-label">{{ permission.rights }}</span>
        }
        <!--screen type label -->
        <span style="margin-left:14px;">{{ permission.screenType }}</span>
        <!-- delete button-->
        @if (userHasInstanceRight(permission)) {
            <div class="float-end" style="margin-top: 4px;">
                <button type="button"
                        class="ace-btn has-icon btn-primary btn-danger"
                        (click)="deletePermission(permission)">
                    <i class="fa fa-trash"></i></button>
            </div>
        }
        <div class="clearfix"></div>
    </div>
}

<!-- add new permission section-->
<div style="margin-top: 10px;">
    <!-- add new right button-->
    @if (!editMode) {
        <div>
            <button type="button" class="ace-btn btn-sm btn-primary" (click)="selectPermissionToAdd()">Add Instance
                Right
            </button>
        </div>
    }

    @if (editMode) {
        <div>
            @if (getUniqueAvailableScreenTypes().length > 0) {
                <div>
                    <!-- permission selection-->
                    <select class="form-select form-select-sm"
                            style="width:100px; display: inline-block;"
                            [(ngModel)]="permissionToAdd.permission"
                            [disabled]="permissionToAdd.screenTypeID === null">
                        @for (permission of screenTypePermissions; track permission) {
                            <option [ngValue]="permission.rightsID">
                                {{ permission.rights }}
                            </option>
                        }
                    </select>
                    <!-- screen type-->
                    <select class="form-select form-select-sm"
                            style="width:auto; display: inline-block;"
                            (change)="screenTypeSelected()"
                            [(ngModel)]="permissionToAdd.screenTypeID">
                        @for (type of getUniqueAvailableScreenTypes(); track type) {
                            <option [ngValue]="type.screenTypeID">
                                {{ type.screenType }}
                            </option>
                        }
                    </select>
                    <span>
                        <!-- save button-->
                        <button class="ace-btn has-icon btn-primary btn-success"
                                style="margin-left: 10px;"
                                type="button"
                                (click)="addPermission()"
                                [disabled]="permissionToAdd.permission === null"><i class="fa fa-save"></i></button>
                        <!-- close button-->
                        <button class="ace-btn has-icon btn-primary btn-danger"
                                type="button"
                                (click)="closeAddPermission()"><i class="fa fa-close"></i></button>
                    </span>
                </div>
            }
            @if (getUniqueAvailableScreenTypes().length === 0) {
                <div>
                    No additional permissions to add
                    <a class="ace-btn btn-secondary btn-xs" (click)="closeAddPermission()">close</a>
                </div>
            }
        </div>
    }
</div>
